import { ButtonKeyboardStateType, VirtualKeyboardStateType, } from '@kubit/web-ui-components/virtualKeyboard/types';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
import { VirtualKeyboardVariantType } from '../variants';
const commonVirtualKeyboardStateProps = (FOUNDATIONS, FONT) => ({
    display: 'grid',
    grid_template_columns: 'repeat(6, 1fr)',
    grid_template_rows: 'repeat(2, 1fr)',
    grid_column_gap: FOUNDATIONS.spacing_00,
    grid_row_gap: FOUNDATIONS.spacing_00,
    overflow: 'hidden',
    background_color: FOUNDATIONS.color_neutral_bg_375,
    min_width: '20.5rem',
    border_style: 'solid',
    border_width: FOUNDATIONS.border_50,
    border_color: FOUNDATIONS.color_neutral_border_150,
    border_radius: FOUNDATIONS.radius_comp_resources_virtualkeyboard_radiussize,
    icon: {
        color: FOUNDATIONS.color_accent_default_primary_icon_100,
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
    },
});
const commonWrapperButtonsProps = {
    grid_area: '1 / 1 / 3 / 6',
    display: 'grid',
    grid_template_columns: 'auto auto auto auto auto',
};
const commonDigitButtonProps = (FOUNDATIONS, FONT) => ({
    cursor: 'pointer',
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
    background_color: FOUNDATIONS.color_neutral_bg_375,
    border_style: 'solid',
    border_right_width: FOUNDATIONS.border_50,
    border_bottom_width: FOUNDATIONS.border_50,
    border_right_color: FOUNDATIONS.color_neutral_border_150,
    border_bottom_color: FOUNDATIONS.color_neutral_border_150,
    padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_150}`,
});
const commonDigitButtonTextProps = (FOUNDATIONS, FONT) => ({
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
    font_variant: TextVariantType.FONT_PARAGRAPH_200,
    color: FOUNDATIONS.color_neutral_font_50,
});
const digitButtonProps = (FOUNDATIONS, FONT) => ({
    wrapper: {
        ...commonWrapperButtonsProps,
        [ButtonKeyboardStateType.DEFAULT]: {
            button: commonDigitButtonProps(FOUNDATIONS, FONT),
            text: commonDigitButtonTextProps(FOUNDATIONS, FONT),
        },
        [ButtonKeyboardStateType.PRESSED]: {
            button: {
                ...commonDigitButtonProps(FOUNDATIONS, FONT),
                background_color: FOUNDATIONS.color_neutral_bg_300,
            },
            text: {
                ...commonDigitButtonTextProps(FOUNDATIONS, FONT),
                font_weight: FONT_WEIGHT.font_bold,
            },
        },
    },
});
const commonRemoveButtonProps = (FOUNDATIONS, FONT) => ({
    justify_content: 'center',
    align_items: 'center',
    grid_area: '1 / 6 / 3 / 7',
    cursor: 'pointer',
    padding: `${FOUNDATIONS.spacing_00} ${FOUNDATIONS.spacing_50}`,
    min_width: '3.5rem',
});
const removeButtonProps = (FOUNDATIONS, FONT) => ({
    [ButtonKeyboardStateType.DEFAULT]: {
        ...commonRemoveButtonProps(FOUNDATIONS, FONT),
    },
    [ButtonKeyboardStateType.PRESSED]: {
        ...commonRemoveButtonProps(FOUNDATIONS, FONT),
        background_color: FOUNDATIONS.color_neutral_bg_300,
    },
});
export const getRegularStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [VirtualKeyboardVariantType.REGULAR]: {
            [VirtualKeyboardStateType.INACTIVE]: {
                container: commonVirtualKeyboardStateProps(FOUNDATIONS, FONT),
                removeButton: removeButtonProps(FOUNDATIONS, FONT),
                digitButtons: digitButtonProps(FOUNDATIONS, FONT),
            },
            [VirtualKeyboardStateType.ACTIVE]: {
                container: {
                    ...commonVirtualKeyboardStateProps(FOUNDATIONS, FONT),
                    box_shadow: SHADOWS.shadow_40,
                },
                removeButton: removeButtonProps(FOUNDATIONS, FONT),
                digitButtons: digitButtonProps(FOUNDATIONS, FONT),
            },
        },
    };
};
//# sourceMappingURL=regular.js.map